import { GlobalStyle } from '../GlobalStyle';
import { AlertProvider } from '../Alerts/AlertProvider';
import { BreezeGradients } from './BreezeGradients';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const BreezeIntelligenceKitProvider = ({
  children
}) => {
  return /*#__PURE__*/_jsxs(AlertProvider, {
    children: [/*#__PURE__*/_jsx(GlobalStyle, {}), /*#__PURE__*/_jsx(BreezeGradients, {}), children]
  });
};